<template>
  <v-container grid-list-md>
    <v-layout>
    <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2>
      <div v-if="this.landings">
        <div v-if="this.landings.length > 0"> 
          <v-layout row wrap>
            <v-flex>  
              <h3 class="headline mt-0 mb-2">Schnellauswahl nach Themen <span v-if="ComputedHeimat"> <strong>in {{ ComputedHeimat }}</strong> 
              <v-btn
                @click="LoescheHeimatStadt()" 
                outline fab small
                v-if="ComputedHeimat">
                 <v-icon >close</v-icon>
              </v-btn></span></h3>  
            </v-flex>
          </v-layout>

          <v-layout  row wrap >
            <v-flex v-for="landing in this.LandingButtonObject" :key="landing.id">
               <div class="text-truncate">
                 <v-btn large  outline :to="{ name: 'Landing', params: landing.landingbutton }"> <h3 class="subheading font-weight-medium">{{ landing.name }} </h3></v-btn>
             </div>
            </v-flex>
          </v-layout>
           
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular indeterminate color="accent" v-if="!connectionlost"></v-progress-circular>
        </div>
      </div>
      <div v-if="connectionlost" class="text-xs-center title my-4">
      <v-icon left>warning</v-icon>  Leider aktuell keine Verbindung möglich, bitte versuchen Sie es später nochmal.
      </div>
    </v-flex>
    </v-layout>
<!-- 
    <v-btn :to="{ name: 'Mitmachen'}">mitmachen</v-btn> 
    <v-btn :to="{ name: 'stellen'}">Stellen</v-btn> -->
  
  </v-container>
</template>
<script>

import axios from 'axios'

export default {
  data: () => ({
    show: false,
    dialog: false,
    landings: [],
    connectionlost: false
  }),
  components: {

  },
  computed: {
    ComputedHeimat: function () {
      return this.$store.state.landing.HeimatStadt
    },
    LandingButtonObject: function () {
      if (this.ComputedHeimat) {
        return this.landings.map(item => ({
          name: item.name,
          id: item.id,
          landingbutton: {
            landing: item.slug,
            stadt: this.ComputedHeimat.toLowerCase()
          }
        }))
      } else {
        return this.landings.map(item => ({ name: item.name, id: item.id, landingbutton: { landing: item.slug }}))
      }
    }
  },
  mounted () {
    const self = this
    axios
      .get('/api/v1/landings')
      .then(response => {
        // console.log(response.data)
        this.landings = response.data
      })
      .catch(function (error) {
        console.log(error)
        self.connectionlost = true
      })
  },
  methods: {
    LoescheHeimatStadt: function () {
      this.$store.dispatch('loescheHeimatStadt')
    }
  }
}
</script>
<style>
</style>